import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
export type VaultHistoryMode = 'totalAssets' | 'totalAssetsUsd';
export interface UseCurrencyModeReturn {
  currency: string;
  setCurrency: (currency: string) => void;
  dataMode: VaultHistoryMode;
  currencyOptions: Array<{
    value: string;
    label: string;
  }>;
}
export function useCurrencyMode(assetSymbol) {
  const $ = _c(10);
  const [currency, setCurrency] = useState("USD");
  const t0 = assetSymbol ?? "Asset";
  const t1 = assetSymbol ?? "Asset";
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      value: t0,
      label: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      value: "USD",
      label: "USD"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = [t2, t3];
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const currencyOptions = t4;
  const dataMode = currency === "USD" ? "totalAssetsUsd" : "totalAssets";
  let t5;
  if ($[6] !== currency || $[7] !== currencyOptions || $[8] !== dataMode) {
    t5 = {
      currency,
      setCurrency,
      dataMode,
      currencyOptions
    };
    $[6] = currency;
    $[7] = currencyOptions;
    $[8] = dataMode;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}